import React from "react";
import {Button, CloseButton, Form, Tab, Tabs } from "react-bootstrap";
import CustomTable from "../../components/CustomTable";
import Select from "react-select";
import {
  allRequestHeaders,
  approvedHeaders,
  pendingHeaders,
  rejectedHeaders,
} from "../../constants/TableConstants"
import InputField from "../../components/InputField";
import SearchIcon from "@mui/icons-material/Search";
import PaginationComponent from "../../components/PaginationComponent";
import Loader from "../../components/Loader";
import useRequestManagementViewController from "../../viewControllers/RequestManagementViewControllers/RequestManagementViewController";
import i18n from "../../constants/Strings";
import { requestTypes } from "./RequestTypes";

const RequestManagement = () => {
  
  const {
    allData,
    currentPage,
    totalPages,
    requestType,
    searchText,
    submitSearch,
    setSearchText,
    setStatus,
    status,
    clearSearchQuery,
    handleSelectedRequestType,
    handlePageChange,
    fetchData,
    isLoading,
  } = useRequestManagementViewController();

  const text = {
    pageHeading: i18n.t('requestManagement.pageHeading'),
    pendingTab: i18n.t('requestManagement.pendingTab'),
    approvedTab: i18n.t('requestManagement.approvedTab'),
    rejectedTab: i18n.t('requestManagement.rejectedTab'),
    allRequestsTab: i18n.t('requestManagement.allRequestsTab'),
    noPendingRequests: i18n.t('requestManagement.noPendingRequests'),
    noApprovedRequests: i18n.t('requestManagement.noApprovedRequests'),
    noRejectedRequests: i18n.t('requestManagement.noRejectedRequests'),
    noAllRequests: i18n.t('requestManagement.noAllRequests'),
  };
  
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <Form
              className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 navbar-search"
              onSubmit={(e) => {
                e.preventDefault();
                submitSearch();
              }}
            >
              <div className="d-flex justify-space-between">
                <div className="input-group">
                  <InputField
                    type="text"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    icon={<SearchIcon />}
                    onIconClick={submitSearch}
                  />
                  {searchText && (
                    <CloseButton className="m-1" onClick={clearSearchQuery} />
                  )}
                </div>
                <div className="px-2">
                  <Select
                    isClearable={true}
                    value={requestType}
                    onChange={handleSelectedRequestType}
                    options={requestTypes}
                    placeholder={"Select request type"}
                    isDisabled={false}
                    isSearchable={false}
                    isLoading={false}
                  />
                </div>
              </div>
            </Form>
          </nav>
          <div className="container-fluid">
            <div className=" mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold txt-primary">
                  {text.pageHeading}
                </h6>
              </div>

              <Tabs
                defaultActiveKey={status}
                id="fill-tab-example"
                className="mb-3"
                fill
                onSelect={(eventKey) => setStatus(eventKey)}
              >
                <Tab eventKey="pending" title={text.pendingTab}>
                  {allData?.length > 0 ? (
                    <CustomTable
                      data={allData}
                      headers={pendingHeaders}
                      viewlink={`/request-management-view`}
                      viewState={{
                        key1: "request_type",
                        key2: "store_name",
                      }}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noPendingRequests}
                    </div>
                  )}
                </Tab>
                <Tab eventKey="approved" title={text.approvedTab}>
                  {allData?.length > 0 ? (
                    <CustomTable
                      data={allData}
                      headers={approvedHeaders}
                      viewlink={`/request-management-view`}
                      viewState={{
                        key1: "request_type",
                        key2: "store_name",
                      }}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noApprovedRequests}
                    </div>
                  )}
                </Tab>
                <Tab eventKey="rejected" title={text.rejectedTab}>
                  {allData?.length ? (
                    <CustomTable
                      data={allData}
                      headers={rejectedHeaders}
                      viewlink={`/request-management-view`}
                      viewState={{
                        key1: "request_type",
                        key2: "comment",
                        key3: "store_name",
                      }}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noRejectedRequests}
                    </div>
                  )}
                </Tab>
                <Tab eventKey="" title={text.allRequestsTab}>
                  {allData?.length > 0 ? (
                    <CustomTable
                      data={allData}
                      headers={allRequestHeaders}
                      viewlink={`/request-management-view`}
                      viewState={{
                        key1: "request_type",
                        key2: "store_name",
                      }}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noAllRequests}
                    </div>
                  )}
                </Tab>
              </Tabs>

              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                data={allData?.length}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RequestManagement;
